import type { Maybe } from '@adornis/base/utilTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { MongoEntity } from '@adornis/baseql/entities/mongoEntity.js';
import type { PartialEntityData } from '@adornis/baseql/entities/types.js';
import { validate } from '@adornis/validation/decorators.js';
import { nonOptional } from '@adornis/validation/functions/nonOptional.js';

@Entity()
export class EmailChangeTracker extends MongoEntity {
  static override _class = 'EmailChangeTracker';
  static override _collectionName = 'email-change-trackers';

  constructor(doc: PartialEntityData<EmailChangeTracker>) {
    super(doc);
  }

  @validate(nonOptional())
  @Field(() => String)
  public userID!: string;

  @validate(nonOptional())
  @Field(() => String)
  public newEmail!: string;

  @validate(nonOptional())
  @Field(() => String)
  public oldEmail!: string;

  @Field(() => Date)
  public startedProcess: Maybe<Date>;

  @Field(() => Date)
  public confirmedOldEmail: Maybe<Date>;

  @Field(() => Date)
  public confirmedNewEmail: Maybe<Date>;
}
